// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"df344eaf","104":"93b761e2","192":"543e6a3a","372":"19ee12d3","432":"6d84debb","589":"a28d1c55","606":"abc026cd","789":"829eaf57","811":"a8683ded","979":"2ab271ee"}[chunkId] + ".chunk.js";
};